import { ActionButtonType } from "@enums/actionButtonType";
import { ArtistVerified } from "@enums/artistVerified";
import { IButtonCategory } from "@interfaces/Shared/buttonCategory";
import BanIcon from "mdi-react/AccountCancelOutlineIcon";
import VerifyIcon from "mdi-react/AccountCheckOutlineIcon";
import FeatureIcon from "mdi-react/AccountStarOutlineIcon";
import { Fragment, ReactElement } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";

export interface IActionButton {
  uuid: string;
  category: IButtonCategory;
  description: string;
  handleModal: Function;
  action?: boolean | ArtistVerified;
  type: ActionButtonType;
}

const actionButtonTypeMap = {
  [ActionButtonType.Ban]: <BanIcon />,
  [ActionButtonType.Verify]: <VerifyIcon />,
  [ActionButtonType.Feature]: <FeatureIcon />,
};

const actionButtonActionMap = {
  [ActionButtonType.Ban]: "banned",
  [ActionButtonType.Verify]: "verified",
  [ActionButtonType.Feature]: "featured",
};

const ActionButton = ({
  uuid,
  category,
  description,
  handleModal,
  action,
  type,
}: IActionButton): ReactElement => (
  <Fragment>
    <UncontrolledTooltip
      placement="top"
      modifiers={{ preventOverflow: { boundariesElement: "window" } }}
      target={`${category.tooltipTarget}${uuid}`}
    >
      {category.tooltipText}
    </UncontrolledTooltip>
    <Button
      className={category.buttonClass}
      onClick={() =>
        handleModal({
          uuid,
          description,
          [actionButtonActionMap[type]]: action,
          actionButtonType: type,
        })
      }
      id={`${category.tooltipTarget}${uuid}`}
    >
      <span>{actionButtonTypeMap[type]}</span>
    </Button>
  </Fragment>
);

export default ActionButton;
